export default __webpack_public_path__ + "static/media/logo.d855b968.jpg";